export enum REFS_ACTION_TYPES {
    SET_GEOJSONLAYER_REF = "refs/SET_GEOJSONLAYER_REF",
    SET_SIDEBAR_REF = "refs/SET_SIDEBAR_REF"
};